module.exports = "/img/team-member-1.aef4253f.png";